/*
 * BeeCaramulo Apiturismo - v0.1.0
 * Author: truebond.pt
 * 
 * Navbar Data
 */

export const NAVBAR = {
    scope: 'bee.Navbar',
    links: [
        { spyid: 'thehouse', href: '#thehouse', text: 'A Casa' },
        { spyid: 'services', href: '#services', text: 'Serviços' },
        { spyid: 'about', href: '#about', text: 'Sobre Nós' },
        { spyid: 'rooms', href: '#rooms', text: 'Quartos' },
        { spyid: 'tovisit', href: '#tovisit', text: 'Onde Estamos' },
        { spyid: 'photos', href: '#photos', text: 'Galeria' },
        { spyid: 'contact', href: '#contact', text: 'Contactos' }
    ]
}